import React, { Fragment, useEffect, useState } from "react";

import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";

import { FiUser, FiCalendar, FiClock } from "react-icons/fi";
import "./Greet.css";
const Greet = () => {
  const [profile, setProfile] = useState({
    name: "",
    phone: "",
    person: "",
    date: "",
    time: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = () => {
    let errors = {};
    const { name, phone, person, date, time } = profile;

    if (!name) errors.name = "Please enter your name!";
    if (!phone) errors.phone = "Please enter your phone number!";
    if (!person) errors.person = "Please enter number of person!";
    if (!date) errors.date = "Please select date!";
    if (!time) errors.time = "Please select time!";

    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });

    if (profile[name]) {
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setIsSubmitting(true);
  //   handleWhatsappRedirect("", "+447442021847");
  // };

  const onSubmit = async (e) => {
    e.preventDefault();
    setFormErrors(validate());
    setIsSubmitting(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmitting) {
      handleWhatsappRedirect("", "+447442021847");
      setIsSubmitting(false);
    }
  }, [formErrors, isSubmitting, profile]);

  const handleWhatsappRedirect = (label, number) => {
    const phoneNumber = number; // Replace with the recipient's phone number
    const formattedMessage = `*Table Booking Inquiry*%0a%0a*Name*: ${profile.name}%0a*Contact No*: ${profile.phone}%0a*Date*: ${profile.date}%0a*Time*: ${profile.time}%0a*Number of People*: ${profile.person}%0a*Message*: ${profile.message}`;

    // Create the WhatsApp URL with the formatted message
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${formattedMessage}`;

    // Redirect the user to the WhatsApp URL
    window.open(
      whatsappURL,
      "_blank" // <- This is what makes it open in a new window.
    );
  };

  return (
    <div className="wrapper">
      {/* <div className="card-wrapper"> */}
      <Card className="d-flex flex-row border-5 rounded-4 border-light bg-dark justify-content-center content-card">
        <Row className="w-100 align-items-center my-3">
          <Col lg={8} md={12}>
            <Card className="text-center border-0  p-4 bg-transparent mb-0 pb-0">
              <h1 className="text-center text-white fs-4">
                Book your delicious table now
              </h1>
              <p className="text-center text-white fs-5">
                Booking request{" "}
                <span className="text-danger">
                  <a href="tel:+447442021847">+44 7442 0218476</a>
                </span>{" "}
                or fill out the order form
              </p>
              <Form onSubmit={onSubmit}>
                <Row>
                  <Col md={6}>
                    <FormGroup className="d-flex flex-column">
                      <Input
                        type="text"
                        name="name"
                        value={profile.name}
                        onChange={handleChange}
                        className="p-2 bg-light border-light border-2 text-white"
                        placeholder="Your Name"
                      />
                      {formErrors.name && (
                        <small className="text-start text-danger">
                          {formErrors.name}
                        </small>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="d-flex flex-column">
                      <Input
                        type="number"
                        name="phone"
                        value={profile.phone}
                        onChange={handleChange}
                        className="p-2 bg-light border-light border-2 text-white"
                        placeholder="Phone Number"
                      />
                      {formErrors.phone && (
                        <small className="text-start text-danger">
                          {formErrors.phone}
                        </small>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <InputGroup
                      className={`${!formErrors.person ? "mb-3" : ""}`}
                    >
                      <InputGroupText className="p-2 bg-light border-light border-2 rounded-start text-white border-end-0">
                        <FiUser />
                      </InputGroupText>
                      <Input
                        type="number"
                        name="person"
                        value={profile.person}
                        onChange={handleChange}
                        className="p-2 bg-light border-light border-2 rounded-end text-white"
                        placeholder="Persons"
                      />
                    </InputGroup>
                    {formErrors.person && (
                      <p className="text-start text-danger mb-3">
                        <small>{formErrors.person}</small>
                      </p>
                    )}
                  </Col>
                  <Col md={4}>
                    <InputGroup className={`${!formErrors.date ? "mb-3" : ""}`}>
                      <InputGroupText className="p-2 bg-light border-light border-2 rounded-start text-white border-end-0">
                        <FiCalendar />
                      </InputGroupText>
                      <Input
                        type="date"
                        name="date"
                        placeholder="dd/mm/yyyy"
                        value={profile.date}
                        onChange={handleChange}
                        className="p-2 bg-light border-light border-2 rounded-end text-white date-time-input"
                      />
                    </InputGroup>
                    {formErrors.date && (
                      <p className="text-start mb-3 text-danger">
                        <small>{formErrors.date}</small>
                      </p>
                    )}
                  </Col>
                  <Col md={4}>
                    <InputGroup className={`${!formErrors.time ? "mb-3" : ""}`}>
                      <InputGroupText className="p-2 bg-light border-light border-2 rounded-start text-white border-end-0">
                        <FiClock />
                      </InputGroupText>
                      <Input
                        type="time"
                        name="time"
                        placeholder="hh:mm"
                        value={profile.time}
                        onChange={handleChange}
                        className="p-2 ps-0 bg-light border-light border-2 rounded-end text-white date-time-input"
                      />
                    </InputGroup>
                    {formErrors.time && (
                      <p className="text-start mb-3 text-danger">
                        <small>{formErrors.time}</small>
                      </p>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Input
                        type="textarea"
                        name="message"
                        rows="4"
                        value={profile.message}
                        onChange={handleChange}
                        className="p-3 bg-light border-light border-2 text-white h-25"
                        placeholder="Message"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      type="submit"
                      color="primary"
                      className="w-100 py-3 bg-danger border-danger"
                    >
                      BOOK A TABLE
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>

          <Col lg={4} md={12}>
            <Card className="text-center border-5 rounded-4 border-light m-4 p-4 bg-light">
              <h3 className="text-white fs-5">Contact Us</h3>
              <h4 className="text-white fs-6">Booking request</h4>
              <h2 className="text-danger fs-6">
                <a href="tel:+447442021847">+44 7442 021847</a>
              </h2>
              <p className="fw-bold text-white mb-0">Location</p>
              {/* <p className="m-0 text-grey mb-0">113-115 Melton Road,</p> */}
              <p className="text-grey mb-0">Leicester, LE4 6QS, UK</p>
              <p className="fw-bold text-white mb-0">Monday</p>
              <p className="m-0 text-grey mb-0">Holiday</p>
              <p className="fw-bold text-white mb-0">Tuesday to Friday</p>
              <p className="text-grey mb-0">12 AM to 8 PM</p>
              <p className="fw-bold text-white mb-0">Saturday & Sunday</p>
              <p className="text-grey mb-0">12 AM to 9 PM</p>
            </Card>
          </Col>
        </Row>
      </Card>
      {/* </div> */}
    </div>
  );
};

export default Greet;
